/* ==========================================================================
   FLAWLESS PDP · gedeelde logica (winkelmand, mandjeslade, geld, video's)
   Wordt door alle flawless-secties gebruikt via window.FLW.
   ========================================================================== */
(function(){
  if (window.FLW) return;

  var locale = document.documentElement.lang || 'nl';

  function money(cents){
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(locale, { style:'currency', currency:cur }).format(cents/100);
    } catch(e){ return '€' + (cents/100).toFixed(2).replace('.', ','); }
  }

  function toast(text){
    var t = document.querySelector('.flw-toast');
    if (!t){ t = document.createElement('div'); t.className = 'flw flw-toast'; t.setAttribute('role','status'); document.body.appendChild(t); }
    t.textContent = text;
    t.classList.add('show');
    clearTimeout(t._t); t._t = setTimeout(function(){ t.classList.remove('show'); }, 2400);
  }

  function updateCount(){
    return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        document.querySelectorAll('#cart-count,[data-cart-count],.cart-count').forEach(function(n){ n.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail:c }));
        return c;
      }).catch(function(){});
  }

  // Zelfde aanpak als bzOpenDrawer in Main Product v2: side-cart vers ophalen en openen.
  function openDrawer(){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + '?section_id=side-cart&_=' + Date.now())
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sec = doc.querySelector('#shopify-section-side-cart');
        var host = document.getElementById('cart');
        if (sec && host){ host.innerHTML = sec.innerHTML; }
        var opener = document.querySelector('a[data-panel="cart"]');
        if (opener){ opener.click(); } else { window.location = '/cart'; }
      }).catch(function(){ window.location = '/cart'; });
  }

  // items: [{id, quantity}]
  function add(items, opts){
    opts = opts || {};
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      if (!r.ok) return r.json().then(function(e){ throw e; });
      return r.json();
    }).then(function(res){
      if (navigator.vibrate){ try{ navigator.vibrate(15); }catch(e){} }
      updateCount();
      if (opts.toast) toast(opts.toast);
      if (window.innerWidth >= 990 || opts.drawer){ openDrawer(); }
      return res;
    }).catch(function(err){
      toast((err && (err.description || err.message)) || 'Er ging iets mis');
      throw err;
    });
  }

  // Knoppen met data-flw-add="id,id,id" overal op de pagina
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-flw-add]');
    if (!b) return;
    e.preventDefault();
    var ids = String(b.getAttribute('data-flw-add')).split(',').filter(Boolean);
    if (!ids.length) return;
    var label = b.innerHTML;
    b.disabled = true;
    add(ids.map(function(id){ return { id: parseInt(id,10), quantity: 1 }; }), { toast: b.getAttribute('data-flw-toast') || '' })
      .then(function(){ b.innerHTML = '✓'; setTimeout(function(){ b.innerHTML = label; b.disabled = false; }, 1600); })
      .catch(function(){ b.disabled = false; });
  });

  // Video's: klik = afspelen met geluid, klik nog eens = pauze
  document.addEventListener('click', function(e){
    var p = e.target.closest('[data-flw-play]');
    if (!p) return;
    var card = p.closest('.flw-vcard'), v = card && card.querySelector('video');
    if (!v) return;
    document.querySelectorAll('.flw-vcard video').forEach(function(o){ if (o !== v){ o.pause(); o.closest('.flw-vcard').classList.remove('is-playing'); } });
    v.muted = false; v.controls = true; v.play(); card.classList.add('is-playing');
  });

  window.FLW = { money:money, add:add, openDrawer:openDrawer, toast:toast, updateCount:updateCount };
})();
